import React, { useEffect, useState } from 'react';
import SitesIssueForm from '../../../components/Campanhas/SitesIssueForm';
import { LoaderFull } from '../../../components/Loader';
import Container from '../../../components/Campanhas/SitesContainer';
import SitesEnum from '../../../services/enums/sites/navItemsEnum';

import api from '../../../services/api';

const SitesTicket = () => {
    const [readyToRender, setReadyTorender] = useState(false);
    const [ticketData, setTicketData] = useState(
        {
            companyName: '',
            documentNumber: '',
            userName: '',
            clientEmail: '',
        },
    );

    useEffect(() => {
        api.get('/users/me')
        .then((response) => {
            const {
                attributes,
                relationships,
            } = response.data.data;
            setTicketData({
                ...ticketData,
                companyName: encodeURI(relationships.customer.nome),
                documentNumber: encodeURI(relationships.customer.cnpj),
                userName: encodeURI(attributes.name),
                clientEmail: encodeURI(attributes.email),
            });
        })
        .then(() => setReadyTorender(true));
    }, []);

    return (
	<Container
		siteHeader="Fale Conosco"
		links={SitesEnum}
	>
		{
                readyToRender && (
                    <SitesIssueForm
	companyName={ticketData.companyName}
	documentNumber={ticketData.documentNumber}
	userName={ticketData.userName}
	clientEmail={ticketData.clientEmail}
                    />
                )
            }
		{
                !readyToRender && <LoaderFull />
            }
	</Container>
    );
};

export default SitesTicket;
